import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Dialog, DialogProps } from '../../components/ui';
import { ExitIcon } from '../../components/icons';
import { SupportForm } from './support-form';
import { Button } from '../../components/ui';

export interface SupportModalProps extends DialogProps {
  onSuccessSubmitted?: () => void;
}

export const SupportModal: React.FC<SupportModalProps> = ({ onClose, onSuccessSubmitted, ...rest }) => {
  const search = useLocation().search;

  const { callReport, callId, option, contactUs } = useMemo(() => {
    const urlSearchParams = new URLSearchParams(search);

    return {
      callReport: urlSearchParams.get('call-report'),
      callId: urlSearchParams.get('call_id'),
      option: urlSearchParams.get('option'),
      contactUs: urlSearchParams.get('error'),
    };
  }, [search]);

  return (
    <Dialog
      className="shadow-modal backdrop:bg-modalBackdropColor w-full max-w-[620px] rounded-xl bg-white p-0"
      onClose={onClose}
      {...rest}
    >
      <div className="border-input-border-gray flex items-start justify-between border-b p-6 md:p-8">
        <div className="flex flex-col gap-2 pr-4">
          <h2 className="font-albert-sans text-2xl font-semibold leading-[30px] tracking-[-0.2px] text-black">
            Support
          </h2>
          <p className="font-['Open_Sans'] text-sm font-normal leading-6 text-gray-700">
            Let us know how we can best provide support for you today.
          </p>
        </div>
        <button
          onClick={onClose}
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors hover:bg-gray-100"
          aria-label="Close modal"
        >
          <ExitIcon color="#22282F" />
        </button>
      </div>
      <div className="p-6 md:p-8">
        <SupportForm
          option={option}
          callReport={callReport}
          callId={callId}
          contactUs={contactUs}
          bottomActionButton={({ isDirty, isSubmitting }) => (
            <div className="border-input-border-gray mt-8 flex justify-end border-t pt-6">
              <Button
                className="bg-button-primary hover:bg-button-primary-hover rounded-full px-8 py-3 font-['Open_Sans'] text-base font-medium leading-5 text-white transition-colors disabled:bg-gray-300"
                variant="primary"
                type="submit"
                disabled={!isDirty || isSubmitting}
                loading={isSubmitting}
              >
                Submit
              </Button>
            </div>
          )}
          onSuccessSubmitted={() => {
            onClose();

            if (onSuccessSubmitted) {
              onSuccessSubmitted();
            }
          }}
        />
      </div>
    </Dialog>
  );
};
